import React, { useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { X, Clock, CheckCircle2, XCircle, RotateCcw, Trash2, Sparkles } from "lucide-react";
import { toast } from "sonner";

const STATUS_STYLE = {
  pending: "bg-[#D97706]/10 text-[#D97706] border-[#D97706]/30",
  sent: "bg-[#059669]/10 text-[#059669] border-[#059669]/30",
  failed: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30",
};
const STATUS_LABEL = { pending: "Antri", sent: "Terkirim", failed: "Gagal" };

const WaQueuePanel = ({ onClose }) => {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/wa/queue");
      setData(data);
    } catch (_) {}
  }, []);

  useEffect(() => {
    load();
    const iv = setInterval(load, 10000);
    return () => clearInterval(iv);
  }, [load]);

  const cancel = async (id) => {
    try {
      await api.delete(`/wa/queue/${id}`);
      toast.success("Pesan dibatalkan");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal membatalkan"); }
  };
  const retry = async (id) => {
    try {
      await api.post(`/wa/queue/${id}/retry`);
      toast.success("Pesan dimasukkan lagi ke antrian");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal retry"); }
  };

  const s = data?.stats || {};
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white border border-[#E4E4E7] w-full max-w-3xl max-h-[85vh] flex flex-col" data-testid="wa-queue-panel">
        <div className="px-6 py-4 border-b border-[#E4E4E7] flex items-center justify-between">
          <div>
            <div className="label-cap">Antrian Pesan WhatsApp</div>
            <p className="text-[10px] text-[#52525B] mt-0.5">Pesan dikirim otomatis satu per satu dengan jeda acak & parafrase AI agar akun aman dari deteksi Meta.</p>
          </div>
          <button onClick={onClose} data-testid="wa-queue-close" className="p-2 hover:bg-[#F4F4F5] border border-[#E4E4E7]"><X size={14} /></button>
        </div>
        <div className="grid grid-cols-4 gap-px bg-[#E4E4E7] border-b border-[#E4E4E7]">
          <div className="bg-white p-3"><div className="label-cap">Antri</div><div className="font-mono font-bold text-lg" data-testid="wa-queue-pending">{s.pending ?? "—"}</div></div>
          <div className="bg-white p-3"><div className="label-cap">Terkirim Hari Ini</div><div className="font-mono font-bold text-lg" data-testid="wa-queue-sent-today">{s.sent_today ?? "—"}/{s.daily_limit ?? "—"}</div></div>
          <div className="bg-white p-3"><div className="label-cap">Sisa Kuota</div><div className="font-mono font-bold text-lg">{s.remaining_today ?? "—"}</div></div>
          <div className="bg-white p-3"><div className="label-cap">AI Parafrase</div><div className={`text-xs font-bold mt-1.5 flex items-center gap-1 ${s.ai_enabled ? "text-[#059669]" : "text-[#DC2626]"}`}><Sparkles size={12} /> {s.ai_enabled ? "AKTIF" : "OFF"}</div></div>
        </div>
        <div className="flex-1 overflow-y-auto">
          {(data?.items || []).length === 0 && <div className="p-8 text-center text-sm text-[#52525B]">Belum ada pesan di antrian.</div>}
          {(data?.items || []).map((it) => (
            <div key={it.id} className="px-4 py-3 border-b border-[#F4F4F5] flex items-start gap-3" data-testid={`wa-queue-item-${it.id}`}>
              <span className={`text-[9px] font-bold uppercase px-1.5 py-0.5 border shrink-0 mt-0.5 ${STATUS_STYLE[it.status] || ""}`}>
                {it.status === "pending" ? <Clock size={9} className="inline mr-0.5" /> : it.status === "sent" ? <CheckCircle2 size={9} className="inline mr-0.5" /> : <XCircle size={9} className="inline mr-0.5" />}
                {STATUS_LABEL[it.status] || it.status}
              </span>
              <div className="min-w-0 flex-1">
                <div className="text-xs font-bold">{it.name || it.phone || it.chat_id} <span className="font-normal text-[#52525B] font-mono">· {it.phone}</span>{it.source && <span className="ml-1 text-[9px] uppercase text-[#7C3AED]">[{it.source}]</span>}</div>
                <div className="text-[11px] text-[#52525B] truncate">{(it.final_text || it.text || "").slice(0, 140)}</div>
                {it.error && <div className="text-[10px] text-[#DC2626] mt-0.5">{it.error}</div>}
              </div>
              <div className="flex gap-1 shrink-0">
                {it.status === "pending" && (
                  <button onClick={() => cancel(it.id)} data-testid={`wa-queue-cancel-${it.id}`} title="Batalkan" className="p-1.5 border border-[#E4E4E7] hover:bg-[#DC2626]/10 text-[#DC2626]"><Trash2 size={12} /></button>
                )}
                {it.status === "failed" && (
                  <button onClick={() => retry(it.id)} data-testid={`wa-queue-retry-${it.id}`} title="Coba lagi" className="p-1.5 border border-[#E4E4E7] hover:bg-[#F4F4F5]"><RotateCcw size={12} /></button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WaQueuePanel;
